// extracted by mini-css-extract-plugin
export default {"Join":"Join_Join__Vt6pY","Join__spacer":"Join_Join__spacer__-lPKW"};